import { ChevronRight } from "lucide-react";
import { AuditTrailTable } from "@/components/admin/AuditTrailTable";

export function ConfigurationHistoryPage() {
  return (
    <>
      <div className="topbar">
        <div className="topbar__crumbs">
          <span>Admin</span>
          <ChevronRight size={14} />
          <strong>Configuration History</strong>
        </div>
      </div>
      <div className="page">
        <div className="page-header">
          <div>
            <h1 className="page-header__title">Configuration History</h1>
            <p className="page-header__sub">
              Audit trail of all admin changes to categories, subtasks, and job types.
            </p>
          </div>
        </div>
        <AuditTrailTable />
      </div>
    </>
  );
}
